if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.setProductTitle(this.dataset.productTitle);
      this.display();
      this.renderFreeShipping();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    display() {
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);
      const dismissDelay = window.innerWidth < 768 ? 2000 : 6000;
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), dismissDelay);

      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open(evt.currentTarget);
            this.dismiss();
          });
        });
      }
    }

    formatMoney(cents) {
      const format = theme.settings.moneyWithCurrencyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.floor(cents / 100).toString();
      const amountWithComma = amount.replace('.', ',');
      const amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return format
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount}}', amount);
    }

    async renderFreeShipping() {
      const fsConfig = theme.settings.freeShipping;
      if (!fsConfig || !fsConfig.enabled || !fsConfig.amounts) return;

      const container = this.querySelector('.added-notification__free-shipping');
      if (!container) return;

      try {
        const response = await fetch(`${theme.routes.cart}.js`, {
          method: 'GET',
          headers: { Accept: 'application/json' }
        });
        const cart = await response.json();

        const lines = fsConfig.amounts.split('\n').map((l) => l.trim()).filter(Boolean);
        let threshold = null;

        for (let i = 0; i < lines.length; i += 1) {
          const parts = lines[i].split(':');
          if (parts.length === 2 && parts[0] === cart.currency) {
            threshold = parseInt(parts[1], 10);
            break;
          }
          if (parts.length === 3 && parts[1] === cart.currency) {
            threshold = parseInt(parts[2], 10);
            break;
          }
        }

        if (threshold === null) return;

        const progress = Math.min(1, Math.max(0, cart.total_price / threshold));
        const deficit = Math.max(0, threshold - cart.total_price);
        const barColor = progress < 1 ? fsConfig.colorUnder : fsConfig.colorMet;
        const met = progress >= 1;

        const compactEl = this.querySelector('.added-notification__compact-message');
        if (compactEl) {
          compactEl.textContent = met
            ? 'Added to cart — free shipping unlocked'
            : `Added to cart — ${this.formatMoney(deficit)} away from free shipping`;
        }

        const deficitTemplate = (theme.strings && theme.strings.freeShippingDeficitHtml) || '';
        const metText = (theme.strings && theme.strings.freeShippingMet) || '';
        const deficitHtml = deficitTemplate.replace(/__AMOUNT__/g, this.formatMoney(deficit));

        const progressAttr = met ? '1' : String(progress);
        const noCartClass = cart.items && cart.items.length === 0 ? ' free-shipping-bar--no-cart' : '';

        container.innerHTML = `
          <div class="free-shipping-bar${noCartClass}"
            data-free-shipping-progress="${progressAttr}"
            style="--free-shipping-progress: ${progress}; --free-shipping-bar-color: ${barColor}">
            <div class="free-shipping-bar__message free-shipping-bar__message--no"></div>
            <div class="free-shipping-bar__message free-shipping-bar__message--yes"></div>
            <div class="free-shipping-bar__bar"></div>
          </div>`;

        const barEl = container.querySelector('.free-shipping-bar');
        const noEl = barEl.querySelector('.free-shipping-bar__message--no');
        const yesEl = barEl.querySelector('.free-shipping-bar__message--yes');
        noEl.innerHTML = deficitHtml;
        yesEl.textContent = metText;
      } catch (error) {
        console.log(error); // eslint-disable-line
      }
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
